/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancersPerArea
 */
export interface FreelancersPerArea {
    /**
     * 
     * @type {string}
     * @memberof FreelancersPerArea
     */
    area: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancersPerArea
     */
    range: string;
    /**
     * 
     * @type {number}
     * @memberof FreelancersPerArea
     */
    count: number;
}

/**
 * Check if a given object implements the FreelancersPerArea interface.
 */
export function instanceOfFreelancersPerArea(value: object): value is FreelancersPerArea {
    if (!('area' in value) || value['area'] === undefined) return false;
    if (!('range' in value) || value['range'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function FreelancersPerAreaFromJSON(json: any): FreelancersPerArea {
    return FreelancersPerAreaFromJSONTyped(json, false);
}

export function FreelancersPerAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersPerArea {
    if (json == null) {
        return json;
    }
    return {
        
        'area': json['area'],
        'range': json['range'],
        'count': json['count'],
    };
}

export function FreelancersPerAreaToJSON(value?: FreelancersPerArea | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'area': value['area'],
        'range': value['range'],
        'count': value['count'],
    };
}

